module.exports = __webpack_public_path__ + "media/images/official/plan_mv-0d84528fc5e820f2e9607c8f715e9961.jpg";